module.exports = __webpack_public_path__ + "static/img/wen-wu-cai-shen-bao-ku.ff83f70.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/wen-wu-cai-shen-bao-ku.jpeg
// module id = 2X4D
// module chunks = 1